import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ShowEventLogsDialogComponent } from '../shared/show-event-logs-dialog/show-event-logs-dialog.component';
import { DatePipe } from '@angular/common';
import { DateFormats } from '../providers/app-date-adapter';
import * as moment from 'moment';
import { EventLog } from '../dto/event-log';

@Injectable()
export class EventLogShowService {

  constructor(
    public dialog: MatDialog,
    private datePipe: DatePipe,
  ) { }

  showLogs(logs) {
    this.dialog.open(ShowEventLogsDialogComponent, {
      data: {
        title: 'Logs',
        list: logs,
      },
      minWidth: 350,
    });
  }

  logsForField(fieldEventLogs: EventLog[], fields, type: string= null) {
    if (fields != null) {
      let f = fields;
      if (!Array.isArray(fields)) {
        f = [fields];
      }
      const result: EventLog[] = [];
      f.forEach(field => {
        result.push(...fieldEventLogs.filter(x => x.field == field));
      });
      result.forEach(x => {
        switch (type) {
        case 'date':
          const d = moment(x.oldValue, DateFormats.MomentParseDate).local();
          x.oldValue =  d.format(DateFormats.MomentDisplayDate);
          break;
        }
      });
      return result;
    }
  }

  logsCount(logs) {
    return logs != null && logs.length != 0 ? logs.length : null;
  }

  getLogTypeName(type: number) {
    switch (type) {
      case 0: return 'New'; // New
      case 1: return 'Deleted'; // Deleted
      case 2: return 'Changed'; // FieldChanged
      case 3: return 'Restored'; // Restored
      case 4: return 'Changed'; // RowChanged
    }
  }
}
